export default __webpack_public_path__ + "static/media/transportealonso.3e18ece1.jpg";